// import axios from 'axios';
// import qs from 'qs';

import appForm from '../mixins/appForm';

export default {
    mixins: [appForm],
    props: {
        successUrl: String,
    },
    recaptcha: null,
    render() {
        return this.$scopedSlots.default({
            ...this.baseRenderProps,
            registerRecaptcha: this.registerRecaptcha,
            onVerify: this.onVerify,
            onSubmit: this.onSubmit,
        });
    },
    methods: {
        registerRecaptcha({ component }) {
            this.$options.recaptcha = component;
        },
        onSubmit(evt) {
            evt.preventDefault();
            this.$options.recaptcha.execute();
        },
        // async onVerify(token) {
        async onVerify() {
            const { formEl: form } = this.$options;

            // const contactUrl = '/actions/contact-form/send';
            const requests = [];

            const selectedIndustry = form.industry.options[form.industry.selectedIndex];
            const selectedIndustryValue = selectedIndustry.value || selectedIndustry.text;

            const selectedOrgSize = form.orgsize.options[form.orgsize.selectedIndex];
            const selectedOrgSizeValue = selectedOrgSize.value || selectedOrgSize.text;

            const selectedJobTitle = form.jobtitle.options[form.jobtitle.selectedIndex];
            const selectedJobTitleValue = selectedJobTitle.value || selectedJobTitle.text;

            const selectedInterests = document.getElementsByName('interest[]');
            const selectedInterestsValue = [];
            for (let i = 0; i < selectedInterests.length; i += 1) {
                if (selectedInterests[i].checked) {
                    selectedInterestsValue.push(selectedInterests[i].value);
                }
            }

            // const contactData = {
            //     fromName: `${form.firstName.value} ${form.lastName.value}`,
            //     'message[Phone]': form.phone.value,
            //     fromEmail: form.email.value,
            //     'message[Industry]': selectedIndustryValue,
            //     'message[OrgSize]': selectedOrgSizeValue,
            //     'message[JobTitle]': selectedJobTitleValue,
            //     'message[Interest]': selectedInterestsValue,
            //     // 'message[body]': form.message.value,
            //     [this.$global.csrfTokenName]: this.$global.csrfTokenValue,
            //     'g-recaptcha-response': token,
            // };

            const mergeTags = {};
            if (selectedIndustryValue && selectedIndustryValue !== 'none') {
                mergeTags.INDUSTRY = selectedIndustryValue;
            }

            if (selectedOrgSizeValue && selectedOrgSizeValue !== 'none') {
                mergeTags.ORGSIZE = selectedOrgSizeValue;
            }

            if (selectedJobTitleValue && selectedJobTitleValue !== 'none') {
                mergeTags.JOBTITLE = selectedJobTitleValue;
            }

            const groups = {};
            if (selectedInterestsValue) {
                groups.Interests = selectedInterestsValue;
            }

            // requests.push(axios.post(contactUrl, qs.stringify(contactData)));
            requests.push(this.mailchimpSubscribe({
                email: form.email.value,
                firstName: form.firstName.value,
                lastName: form.lastName.value,
                mergeTags,
                tags: 'Full-Circle',
                groups,
            }));

            const [{ data }] = await Promise.all(requests);
            // eslint-disable-next-line no-console
            console.log(data);
            // if (data.success) {
            window.location.href = this.successUrl;
            // }
        },
    },
};
